import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from './users.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    private toastrService: ToastrService;

    private userService: UserService;

    constructor(private injector: Injector) { }

    handleError(error) {
        this.userService = this.injector.get(UserService);

        this.toastrService = this.injector.get(ToastrService);

        if (error instanceof HttpErrorResponse) {

            if (error.status == 0) {

                this.toastrService.error("Erreur d'authentification !", "Erreur", { onActivateTick: true });
                this.userService.logout();

            } else {

                let exceptionResponse: ExceptionResponse = new ExceptionResponse();

                try {
                    Object.assign(exceptionResponse, JSON.parse(error.error));
                } catch (e) {
                    Object.assign(exceptionResponse, error.error);
                }

                if (exceptionResponse.errorMessage || exceptionResponse.errorDetails) {
                    let textError = exceptionResponse.errorMessage;
                    if (exceptionResponse.errorDetails) textError += '<br>' + exceptionResponse.errorDetails;

                    this.toastrService.error(textError, exceptionResponse.errorCode, { onActivateTick: true });
                } else {
                    this.toastrService.error("Erreur", null, { onActivateTick: true });
                }


            }

        } else {
            console.error('It happens: ', error);
        }

    }

}

export class ExceptionResponse {

    errorCode: string;
    errorMessage: string;
    errorDetails: string;

    constructor() { }
}